angular.module("digitalLeasing.module").component("financialAppropriateVerificationOld", {
    templateUrl: "ng/components/digitalLeasing/financialAppropriateVerification/financialAppropriateVerificationOld.view.html",
    bindings: {
        model: "=",
        leasingData: "=",
        validateIban: "&",
        invalidateIban: "&",
        validateSubject: "&",
        snapshot: '<',
        portalRunned: "<"
    },
    controllerAs: "finAppropriateVerificationOldCtrl",
    controller: FinAppropriateVerificationOldController
});

function FinAppropriateVerificationOldController(
    CodiceNaturaClientela,
    MotivoRapporto,
    $portalService,
    $configService
) {
    var self = this;

    self.$onInit = function () {

        self.supportModel = {
            options: ["AZIENDA", "PERSONA"],
            defaultOptions: "AZIENDA",
            initialSubject: "",
            subectAdv: "ADV"
        }

        self.validateCheckBox();

        self.validateSubject({ value: true });
        self.checkReteVenditaLogged();
    };

    self.handleStructureChange = function (property, value) {
        switch (property) {
            case "adeguataVerifica":
                self.model.financialCustomer.metadata.adeguataVerifica.codiceNaturaClientela = CodiceNaturaClientela.build({
                    description: value.codiceNaturaClientela.description,
                    name: value.codiceNaturaClientela.name,
                    value: value.codiceNaturaClientela.value,
                });
                self.model.financialCustomer.metadata.adeguataVerifica.motivoRapporto = MotivoRapporto.build({
                    description: value.motivoRapporto.description,
                    name: value.motivoRapporto.name,
                    value: value.motivoRapporto.value,
                });
                self.model.financialCustomer.metadata.adeguataVerifica.provinciaAttivita = value.provinciaAttivita;
                break;
            case "categoria":
                self.model.financialCustomer.metadata.codiceCategoria = value;
                break;
            case "firmaDigitale":
                self.model.leasingData.preventivo[property] = value;
                break;
            case "modalitaInvioDocumentazione":
                self.model.financialCustomer.metadata[property] = value;
                break;
            case "autorizzazione":
                self.model.financialCustomer.metadata.adeguataVerifica.ibanRiconoscimento = value;
                break;
            default:
                break;
        }
    };

    self.getSubject = function (value) {
        if (value && self.validityCustomerDigital) {
            if (value.riUserG) {
                self.model.financialCustomer.metadata.adeguataVerifica.responsabileADV.isPersona = false;
                self.model.financialCustomer.metadata.adeguataVerifica.responsabileADV.riUserG = value.riUserG;
            } else {
                self.model.financialCustomer.metadata.adeguataVerifica.responsabileADV.isPersona = true;
                self.model.financialCustomer.metadata.adeguataVerifica.responsabileADV.riUserF = value.riUserF;
            }
        }
    }

    self.exportValidityCustomerDigital = function (validity) {
        self.validityCustomerDigital = validity;

        self.validateSubject({
            value: self.validityCustomerDigital
        });
    }

    self.ibanIsOk = function () {
        self.validateIban();
    };

    self.ibanIsNotOk = function () {
        self.invalidateIban();
    };

    self.validateCheckBox = function (value) {
        var test = true;

        if ($portalService.isAru()) {
            test = value
        }

        if (test) {
            self.validateIban();
        } else {
            self.invalidateIban();
        }

    }
    self.checkReteVenditaLogged = function () {
        self.currentUser = $configService.getUser();
        var functionalities = $configService.getAppConfig().allFunctionalities;
        if ((self.currentUser.reteVendita != 2 && self.currentUser.reteVendita != 0) || functionalities.includes("ACQ_CONTRATTI")) {
            self.perdicDocIsCollapsed = true;
        }
        else self.perdicDocIsCollapsed = false;
    }
}